module.exports = __webpack_public_path__ + "static/media/SG.fb4f084d.png";